import React, { createContext, useContext, useState } from "react";

const WorkerProfileContext = createContext();

export const WorkerProfileProvider = ({ children }) => {
  const [selectedWorkerProfile, setSelectedWorkerProfile] = useState(null);

  return (
    <WorkerProfileContext.Provider value={{ selectedWorkerProfile, setSelectedWorkerProfile }}>
      {children}
    </WorkerProfileContext.Provider>
  );
};

// ✅ Unique hook
export const useWorkerProfileContext = () => useContext(WorkerProfileContext);